import React, { Component } from "react";

import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";

import Footer from "../../Footer";
import menus from "../Helpers/menus";

import colors from "../../colors";
import info from '../../info.png'
import decode from "jwt-decode";
import {withRouter} from 'react-router'
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import { AuthConsumer } from "../../AuthContext";
import HeaderCommon from "../../HeaderCommon";
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      active:props.match.url==='/webgis-flood'?'Flood Home':props.match.url==='/webgis-flood/map'?'Flood Geoportal':props.match.url==='/webgis-flood/proj-obj'?'Objective':props.match.url==='/nhp-data-download'?'Download Products':null,
      isOpen: false,
      floodmodal:true,
    };
  }
  toggle=()=>{
    this.setState({
      floodmodal:!this.state.floodmodal
    })
  }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
    this.onClick()
  }
  componentDidUpdate(prevProps,prevState)
  {
    if(this.props.match.url!==prevProps.match.url)
    {
     this.setState({
      active:this.props.match.url==='/webgis-flood'?'Flood Home':this.props.match.url==='/webgis-flood/map'?'Flood Geoportal':this.props.match.url==='/webgis-flood/proj-obj'?'Objective':this.props.match.url==='/nhp-data-download'?'Download Products':null,
     })
    }
  }
  render() {
    const activeStyle = { color: "#ff3333" };
    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
    const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
        //this properties are available as a props in child components
         floodmodal:this.state.floodmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    return (
      <div className="wrapper">
        <HeaderCommon
          title="Spatial Flood Early Warning System"
          screentitle="Flood Early Warning"
          bhuvanlink={true}
        />

        <Navbar
          dark
          expand="lg"
          scrolling
          style={{ background: colors["final_header"], fontSize: "14px",fontWeight: "bold" }}
        >
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>{menuList}</NavbarNav>
            <NavbarNav right>
              <NavItem>
                <NavLink to="/webgis-flood/map">
                  <Menu.Item
                    name="Flood Geoportal"
                    style={
                      this.state.active === "Flood Geoportal" ? activeStyle : {}
                    }
                    onClick={this._handleClick.bind(this, "Flood Geoportal")}
                  />
                </NavLink>
                {/* <a href="https://bhuvan-app1.nrsc.gov.in/fews/" target="_blank" without="true" rel="noopener noreferrer"><Menu.Item name="Flood Geoportal" /></a>  */}
              </NavItem>
              {!this.state.floodmodal?<NavItem className="content"><img src={info}  style={{ width: "20px", height: "20px", cursor: "pointer" }}  onClick={this.toggle} title="About"/></NavItem> :null}
            </NavbarNav>
            {/* <AuthConsumer>
      {({isAuth,logout})=>(
        <NavbarNav right>
          {(isAuth)||(localStorage.getItem("token")!==null) ? (
            <NavbarNav right>
            <NavItem>{console.log(decode(localStorage.getItem('token')))}
            { decode(localStorage.getItem('token')).trainee==='trainee'?<Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button>:
                            <Link to={`/profile/${decode(localStorage.getItem('token')).id}`}><Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button></Link>
                            }      </NavItem>
            <NavItem><Button className="btn-sm" onClick={logout}>logout</Button></NavItem>
            </NavbarNav>
          ):(
            <NavbarNav right>
            <NavItem>
              <NavLink to="/login">Login</NavLink>
             
            </NavItem>
            
             </NavbarNav>
            
       
            
          )}
          
        </NavbarNav>
      )}
    </AuthConsumer>      */}
          </Collapse>
        </Navbar>

    <div className="main">{childrenWithExtraProp}</div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
